<template>
  <div>
    <div>{{ users.length }} comptes administrateurs ont été créé pour ce module</div>
    <v-list density="compact">
      <v-list-item v-for="(user, i) in users" :key="i" :value="user" color="primary">
        <template v-slot:prepend>
          <v-chip density="compact" color="darkblue" variant="elevated" elevation="0" class="mr-2">{{
            get_privilege_text(user.privilege) }}</v-chip>
        </template>

        <v-list-item-title>{{ user.username }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import AdminService from "@/services/admin.service.js";
export default {
  data() {
    return {
      users: [],
    };
  },
  computed: {
    ...mapStores(useMainStore),
  },
  methods: {
    get_privilege_text(privilege) {
      switch (privilege) {
        case "admin":
          return "Organisateur";
        default:
          return privilege;
      }
    },
  },
  async created() {
    let request = await AdminService.getAuthorizedUsers(this.mainStore.module.id);
    if (request) {
      this.users = request;
    }
  },
};
</script>

<style lang="scss" scoped></style>